import { render, staticRenderFns } from "./EdgeVideoThumbnailPreview.vue?vue&type=template&id=58ec3336"
import script from "./EdgeVideoThumbnailPreview.vue?vue&type=script&lang=ts"
export * from "./EdgeVideoThumbnailPreview.vue?vue&type=script&lang=ts"
import style0 from "./EdgeVideoThumbnailPreview.vue?vue&type=style&index=0&id=58ec3336&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports